var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"charge-currency"},[_vm._v(_vm._s(_vm.chargeShowCurrency))]),_vm._v(_vm._s(parseFloat(_vm.chargeAmount).toFixed(2)))])
}
var staticRenderFns = []

export { render, staticRenderFns }